import Common from '../../../Common';

interface Body {
	timeout: string | number
	delay: string | number
	to: string | number
	id: id
	priority: string | number
}

const Item = class extends Common {
	async browse(profileId: id, callRoutingId: id) {
		return this.get(`/profile/${profileId}/callrouting/${callRoutingId}/item`)
	}

	async read(profileId: id, callRoutingId: id, callRoutingItemId: id) {
		return this.get(`/profile/${profileId}/callrouting/${callRoutingId}/item/${callRoutingItemId}`)
	}

	async create(profileId: id, callRoutingId: id, body: Body) {
		return this.post(`/profile/${profileId}/callrouting/${callRoutingId}/item`, body)
	}

	async update(
		profileId: id,
		callRoutingId: id,
		callRoutingItemId: id,
		body: Body
	) {
		return this.patch(`/profile/${profileId}/callrouting/${callRoutingId}/item/${callRoutingItemId}`, body)
	}

	async delete(profileId: id, callRoutingId: id, callRoutingItemId: id) {
		return this.doDelete(`/profile/${profileId}/callrouting/${callRoutingId}/item/${callRoutingItemId}`)
	}
}

export default Item;
